import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'

export function Button({children, onClick, ...props}) {
  return (
    <AtomButton
      color={atomButtonColors.PRIMARY}
      design={atomButtonDesigns.SOLID}
      fullWidth
      link
      onClick={onClick}
      shape={atomButtonShapes.CIRCULAR}
      size={atomButtonSizes.LARGE}
      {...props}
    >
      {children}
    </AtomButton>
  )
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
}
